(function () {
  'use strict';

  angular.module('app').factory('ShortenerService', ShortenerService);

  ShortenerService.$inject = ['API'];

  function ShortenerService(API) {
    var service = {};

    /**
     * Get url property by short URL code
     */
    service.Get = function (code, callback) {
      API.get('/shortener/code/' + code, function (success, data) {
        callback(success, data);
      });
    };

    /**
     * Get url property by short URL
     */
    service.GetUrlByShortLink = function (code, url, callback) {
      API.post('/shortener/code', { code, url }, function (success, data) {
        callback(success, data);
      });
    };

    /**
     * Generate Short URL for URL
     */
    service.Create = function (url, callback) {
      API.post('/shortener/url', { url }, function (success, data) {
        callback(success, data);
      });
    };

    return service;
  }
})();
